exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3VGAV{padding:10px 18px 15px}.sBg4s{padding:3px 0 8px;font-size:14px;font-weight:400;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row nowrap;flex-flow:row nowrap}._37s8f{padding-top:8px}.eclbw{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:135px;color:#888;padding-right:5px}._3LJ3s,.eclbw{position:relative}._3LJ3s{padding-left:0;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;width:calc(100% - 135px)}._14fTT{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}", ""]);

// exports
exports.locals = {
	"root": "_3VGAV",
	"row": "sBg4s",
	"LeasingFormStyle": "_37s8f",
	"col": "eclbw",
	"colAuto": "_3LJ3s",
	"blockLeftFlex": "_14fTT"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/AdvertInfo_Old/AdvertInfo.css
// module id = 3125
// module chunks = 36